import gql from "graphql-tag";

// Contract only. The draft screen does not invoke this mutation without a trusted actor integration.
export default gql`
  mutation saveBloombergJob(
    $input: BloombergJobInput!
    $job_id: ID
    $expected_revision: Int!
    $command_id: ID!
  ) {
    saveBloombergJob(
      input: $input
      job_id: $job_id
      expected_revision: $expected_revision
      command_id: $command_id
    ) {
      status
      job {
        id
        revision
        state
        definition {
          name
          identifiers
          category_ids
          request_kind
          schedule_id
          start_date
          end_date
          profile_id
          fields
          universe_hash
          definition_hash
        }
        created_at
        updated_at
      }
      issues {
        code
        message
        index
        identifier
      }
      message
    }
  }
`;